import React, { useState, useEffect, Fragment } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { media } from 'helpers/MediaHelper';

import ResidentList from './ResidentList';
import ResidentComments from './ResidentComments';
import CommentList from './CommentList';
import PostCommentButton from './PostCommentButton';

import { submitNote, getNotes } from 'actions/maintenanceTicketActions';
import { getResidents } from 'components/landlord_app/maintenance/tickets/store/actions';

const BodyContent = styled.div`
  padding: 24px 24px 35px;
  ${media.mobile`
    padding: 24px 24px 80px;
  `};
  overflow-y: scroll;
  height: inherit;
`;

const ResidentsContainer = ({
  ticketID,
  mode = 'edit',
  getNotes,
  submitNote,
  comments,
  isFetchingComments,
  residents,
  getResidents,
  unitID,
  setIsLoading,
  onSubmissionComplete,
  showResidentsComments,
}) => {
  const [comment, setComment] = useState(undefined);

  useEffect(
    () => {
      async function asyncEffectFunction(ticketID) {
        await getNotes(ticketID);
        setIsLoading(false);
      }

      setIsLoading('no_text');
      getResidents(ticketID);

      asyncEffectFunction(ticketID);
    },
    // eslint-disable-next-line
    [ticketID, getNotes, getResidents, unitID]
  );

  const handleCreateNote = async () => {
    setIsLoading(true);
    await submitNote({ text: comment }, ticketID);
    await getNotes(ticketID);
    setComment(undefined); // clear the input field
    onSubmissionComplete();
  };

  const handleCommentChange = event => {
    setComment(event.target.value);
  };

  return (
    <BodyContent>
      <ResidentList residents={residents} />
      {showResidentsComments && (
        <Fragment>
          <ResidentComments handleChange={handleCommentChange} comment={comment} />
          <PostCommentButton handleClick={handleCreateNote} disabled={!comment} />
          {mode === 'edit' && <CommentList comments={comments} />}
        </Fragment>
      )}
    </BodyContent>
  );
};

const mapStateToProps = store => ({
  comments: store.maintenanceTicket.maintenanceTicketNotes,
  isFetchingComments: store.maintenanceTicket.fetchingNotes,
  residents: store.landlord.maintenance.serviceRequests.residents,
  unitID: store.maintenanceTicket.ticketDetails.unit_id,
  showResidentsComments: store.companyDetails.companyPreferences.active_tenant_portal,
});

const mapDispatchToProps = {
  getNotes,
  submitNote,
  getResidents,
};

export default connect(mapStateToProps, mapDispatchToProps)(ResidentsContainer);
